/* eslint-disable no-undef */
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { LogLevel } from "@azure/msal-browser";

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_CLIENTID,
    authority: process.env.REACT_APP_AUTHORITY,
    redirectUri: window.location.origin
  },
  cache: {
    cacheLocation: "sessionStorage", // This configures where your cache will be stored
    storeAuthStateInCookie: false // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
          default:
            return;
        }
      }
    }
  }
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
  scopes: JSON.parse(process.env.REACT_APP_SCOPES)
};

export const powerBiRequest = {
  scopes: JSON.parse(process.env.REACT_APP_POWERBI_SCOPES)
};

export const graphRequest = {
  scopes: JSON.parse(process.env.REACT_APP_GRAPH_SCOPES)
};

export const oneClickRequest = {
  scopes: JSON.parse(process.env.REACT_APP_ONECLICK_SCOPES)
};

export const kqlRequest = {
  scopes: JSON.parse(process.env.REACT_APP_KUSTO_SCOPES),
};

export const mcpRequest = {
  scopes: JSON.parse(process.env.REACT_APP_MCP_SCOPES)
};

export const powerPlatformRequest = {
  scopes: ["https://api.powerplatform.com/.default"]
};
/**
 * Add here the scopes to request when obtaining an access token for MS Graph API. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const graphConfig = {
  graphMeEndpoint: "Enter_the_Graph_Endpoint_Herev1.0/me" // E.g. https://graph.microsoft.com/v1.0/me
};

export const getATK = (instance, scopes, account) =>
  instance.acquireTokenSilent({
    scopes,
    account
  });

export const REFRESH_THRESHOLD = 300; // 5 minutes in seconds
export const TOKEN_CHECK_INTERVAL = 60000; // 1 minute in milliseconds
